import { lazy } from 'react';

export const LoginContainer = lazy(() => import('containers/Login'));
export const UsersContainer = lazy(() => import('containers/Users'));
export const MessagesContainer = lazy(() => import('containers/Messages'));
export const PageNotFoundContainer = lazy(() =>
    import('containers/PageNotFound')
);
export const CreateContentContainer = lazy(() =>
    import('containers/CreateContent')
);
export const ContentListContainer = lazy(() =>
    import('containers/ContentList')
);
export const PersonalisationOptionsContainer = lazy(() =>
    import('containers/PersonalisationOptions')
);
export const VouchersContainer = lazy(() => import('containers/Vouchers'));
export const GroupModerationContainer = lazy(() => import('containers/GroupModeration'));
export const DashboardContainer = lazy(() => import('containers/Dashboard'));
export const ProfileContainer = lazy(() => import('containers/Profile'));
export const QuestionsContainer = lazy(() => import('containers/Questions'));
export const QuestionEditorContainer = lazy(() => import('containers/QuestionEditor'));
export const QuestionnairesContainer = lazy(() => import('containers/Questionnaires'));
export const QuestionnaireEditorContainer = lazy(() => import('containers/QuestionnaireEditor'));
export const QuestionnaireResultsContainer = lazy(() => import('containers/QuestionnaireResults'));
export const QuizzesContainer = lazy(() => import('containers/Quizzes'));
export const QuizEditorContainer = lazy(() => import('containers/QuizEditor'));
export const QuizPreviewContainer = lazy(() => import('containers/QuizPreview'));
export const HealthJourneysContainer = lazy(() => import('containers/HealthJourneys'));
export const HealthJourneyEditorContainer = lazy(() => import('containers/HealthJourneyEditor'));
export const HealthDataExportsContainer = lazy(() => import('containers/HealthDataExports'));
